import React from 'react';
import SingleSignOnDialog from './SingleSignOnDialog';
import useCognitoHostedUIError from './useCognitoHostedUIError';
import useSsoError from './useSsoError';

const SingleSignOnContext = React.createContext<() => void>(() => { });
export default function useSingleSignOnContext() { return React.useContext(SingleSignOnContext); }

export function SingleSignOnContextProvider({ children }: { children: React.ReactNode }) {
  useCognitoHostedUIError();
  const ssoError = useSsoError();
  const [isOpen, setDialogOpen] = React.useState(false);

  React.useEffect(() => {
    if (ssoError) {
      setDialogOpen(true);
    }
  }, [ssoError]);

  const openDialog = React.useCallback(() => { setDialogOpen(true); }, [setDialogOpen]);
  return (
    <SingleSignOnContext.Provider value={openDialog}>
      {children}
      <SingleSignOnDialog open={isOpen} onClose={() => { setDialogOpen(false); }} ssoError={ssoError} />
    </SingleSignOnContext.Provider>
  );
}
